import React, { FC } from 'react';

import { EvBodyDefault, EvFlexColumn, EvMainTitle, TEXT_COLOR } from '@evinced-private/ui-common';

import { LabelManagementPageHeaderProps } from './LabelManagementPageHeader.types';

export const LabelManagementPageHeader: FC<LabelManagementPageHeaderProps> = ({
	title,
	subtitle
}) => {
	return (
		<EvFlexColumn gap="SMALL">
			<EvMainTitle>{title}</EvMainTitle>
			<EvBodyDefault color={TEXT_COLOR.CONTENT_2}>{subtitle}</EvBodyDefault>
		</EvFlexColumn>
	);
};
